import { apiClient } from '@/api/client'
import type { ApiSuccessResponse, PaginationMeta } from '@/types/api'

export type EmploymentType = 'full_time' | 'part_time' | 'internship' | 'contract' | 'freelance'
export type WorkMode = 'onsite' | 'remote' | 'hybrid'

export interface ScreeningQuestion {
  id: number
  questionText: string
  questionType: 'text' | 'yes_no' | 'multiple_choice' | 'dropdown'
  isRequired: boolean
  sortOrder: number
  options: string[]
}

export interface StudentJob {
  id: number
  organizationName: string
  organizationLogoUrl: string | null
  title: string
  description: string
  employmentType: EmploymentType
  workMode: WorkMode
  locationCity: string | null
  locationState: string | null
  locationCountry: string | null
  experienceMinMonths: number | null
  experienceMaxMonths: number | null
  salaryMin: number | null
  salaryMax: number | null
  currency: string | null
  skillsRequired: string[]
  educationRequired: string[]
  applicationDeadline: string | null
  screeningQuestions: ScreeningQuestion[]
  publishedAt: string | null
  hasApplied: boolean
  applicationStatus: string | null
}

export interface StudentJobFilters {
  q?: string
  location_city?: string
  employment_type?: string
  work_mode?: string
  per_page?: number
  page?: number
}

export const jobsApi = {
  list: async (filters: StudentJobFilters) => {
    const { data } = await apiClient.get<
      ApiSuccessResponse<StudentJob[]> & { meta: PaginationMeta }
    >('/students/jobs', { params: filters })
    return { jobs: data.data, meta: data.meta }
  },

  get: async (jobId: number) => {
    const { data } = await apiClient.get<ApiSuccessResponse<StudentJob>>(`/students/jobs/${jobId}`)
    return data.data
  },
}
